import React from "react";
import {amenityService} from "../jwt/_services/hotel/amenityService";

export const amenityProvider = {
    getOptions,
    getAllByCategory,
    getItem
};


async function getOptions(customFilter) {
    try {
        const listItems = await amenityService.getOptions(customFilter);
        return listItems.map( item => ({
                id: item?.id,
                value: item?.code,
                label: <><label><strong>{item?.code} - </strong>{item?.title}</label></>
        }));
    } catch (error) {
        console.log(error.message);
    }
}

async function getAllByCategory( idCategory ) {
    try {
        const listItems = await amenityService.getAllByCategory( idCategory );
        return listItems?.map((itemData) => {
            const {id, code, description} = itemData
            return (
                {
                    id: id,
                    value: code ,
                    label: <div><label>{description}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}


async function getItem(id) {
    try {
        const item = await amenityService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.description}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message);
    }
}